// extracted by mini-css-extract-plugin
export default {"AppFormButton":"Form_AppFormButton__cQG48"};